import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import { required } from 'vuelidate/lib/validators';
import status from '../status';
export default {
  name: 'expiryAlert',
  components: {
    status
  },
  watch: {
    currentPage: function () {
      this.getExpiryAlertData();
    },
    perPage: function () {
      this.currentPage = 1;
      this.getExpiryAlertData();
    },
    currentPage1: function () {
      this.getStatusData();
    },
    perPage1: function () {
      this.currentPage1 = 1;
      this.getStatusData();
    }
  },
  data() {
    return {
      parent_value_set_id: null,
      showValueSetModal: false,
      payload: null,
      unsubscribe: null,
      currentPage: 1,
      totalRows: null,
      perPage: commonHelper.perPageRecord,
      currentPage1: 1,
      totalRows1: null,
      perPage1: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      loader: false,
      vsetCode: null,
      setTimeVsetCode: null,
      days: {
        text: null,
        value: null
      },     
      expiryData: [],
      weighMachineFields: [
        {
          key: 'serial_num',
          label: 'S.No.'
        },
        {
          key: 'location'
        },
        {
          key: 'doc_num',
          label: 'Document No.'
        },
        {
          key: 'exp_date',
          label: 'Expiry Date'
        },
        {
          key: 'oracle_id',
        }
      ],
      rowData: null,
      showStatusDocModalFlag: false,
      docNo: null,
      statusData: [],
      statusFields: [
        
        {
          key: 'serail_no',
          label: 'S.No.'
        },
        {
          key: 'doc_num',
          label: 'Document No.'
        },
        {
          key: 'le_name',
          label: 'Legal Entity'
        },
        {
          key: 'po_number'
        },
        {
          key: 'org_name',
          label: 'Cost Center'
        },
        {
          key: 'description'
        },
        {
          key: 'oracle_id'
        },
        {
          key: 'book_type_code',
          label: 'Book Type'
        },
        {
          key: 'actual_cost'
        },
        {
          key: 'hsn_sac_code',
          label: 'HSN / SAC Code'
        },
        {
          key: 'asset_status'
        },
        {
          key: 'model_number',
          label: 'Model No.'
        },
        {
          key: 'installation_date'
        },
        {
          key: 'accuracy_resolution'
        },
        {
          key: 'department_user_responsible"',
          label: 'Department'
        },
        {
          key: 'capacity_unit'
        },
        {
          key: 'exp_date',
          label: 'Expiry Date'
        },
        {
          key: 'calib_date',
          label: 'Calibration Date'
        },
      ]
    };
  },
  validations: {
    days: {
      text: {
        required
      },
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          // this.showHideAdditionalModal(true);
        }
      }
    });
  },
  methods: {
    getExpiryAlertData() {  
      this.$v.$touch();
      if (!this.$v.$invalid) {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        days: this.days.value,
      };
      this.loader = true;
      this.$store
        .dispatch('weighMachine/getExpiryAlertData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.expiryData = resp.data.data.page;
            this.totalRows = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.DAYS) {
          this.days = {
            value: item.value_meaning,
            text: item.value_code
          };
      } 
      this.showValueSetModal = false;
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      this.vsetCode = vsetCode;
      if (this.vsetCode === appStrings.VALUESETTYPE.DAYS) {
        this.days = {
          value: null,
          text: null
        };
      }
    },
    clear() {
      this.days = {
        text: null,
        value: null
      };
      this.parent_value_set_id = null;
      this.totalRows = null;
      this.expiryData = [];
    },
    showHideStatusModal(flag, item){
      this.statusList = item;
      this.showStatusDocModalFlag = flag;
      if(flag){
      this.getStatusData();
      }
    },
    getStatusData() {
      const payload = {
        _page: this.currentPage1 - 1,
        _limit: this.perPage1,
        doc_num: this.statusList.doc_num,
      };
      this.loader = true;
      this.$store
        .dispatch('weighMachine/getStatusData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.statusData = resp.data.data;
            this.totalRows1 = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
  beforeDestroy() {
    clearTimeout(this.setTimeVsetCode);
    this.unsubscribe();
  }
};
